/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */

import * as React from 'react';
import s from '../Carousel.scss';
import {Arrow, ArrowDirection} from './Arrow/Arrow';
import {CarouselAriaLabels} from '../Carousel';
import classNames from 'classnames';
import {ImageCarouselPaginationVisibility} from '../../../../types/galleryTypes';

export enum CarouselDesktopDataHooks {
  PreviousArrow = 'left-arrow',
  NextArrow = 'right-arrow',
  Carousel = 'carousel',
  CarouselDesktop = 'carouselWrapper',
}

export interface CarouselDesktopProps {
  shouldShowArrowsOnHover: boolean;
  showNavigationArrows: boolean;
  paginationVisibility: ImageCarouselPaginationVisibility;
  ariaLabels: CarouselAriaLabels;
  slideNext: () => void;
  slidePrev: () => void;
  pagination?: React.ReactNode;
}

export const CarouselDesktop: React.FC<CarouselDesktopProps> = (props) => {
  const {slidePrev, slideNext, showNavigationArrows, paginationVisibility, ariaLabels, pagination} = props;

  const showOnHover = paginationVisibility === ImageCarouselPaginationVisibility.ON_HOVER;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      slidePrev();
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      slideNext();
    }
  };

  return (
    <div
      data-hook={CarouselDesktopDataHooks.CarouselDesktop}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      className={classNames(
        s.carouselWrapper,
        showOnHover && s.showArrowsOnHover,
        showOnHover && s.showPaginationOnHover
      )}>
      {showNavigationArrows && (
        <Arrow
          ariaLabel={ariaLabels.arrowLeft}
          dataHook={CarouselDesktopDataHooks.PreviousArrow}
          onClick={slidePrev}
          onKeyPress={slidePrev}
          direction={ArrowDirection.LEFT}
          className={s.arrow}
        />
      )}
      <div
        className={s.carousel}
        data-hook={CarouselDesktopDataHooks.Carousel}
        tabIndex={showNavigationArrows ? undefined : 0}>
        {props.children}
      </div>
      {showNavigationArrows && (
        <Arrow
          ariaLabel={ariaLabels.arrowRight}
          dataHook={CarouselDesktopDataHooks.NextArrow}
          onClick={slideNext}
          onKeyPress={slideNext}
          direction={ArrowDirection.RIGHT}
          className={s.arrow}
        />
      )}
      {pagination && <div className={s.pagination}>{pagination}</div>}
    </div>
  );
};
